module.exports = __webpack_public_path__ + "assets/img/userTitle.760f2ee1.png";